import { render, staticRenderFns } from "./AppMultiPicker.vue?vue&type=template&id=b60689e6&"
import script from "./AppMultiPicker.vue?vue&type=script&lang=js&"
export * from "./AppMultiPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports